import doCategorySearch from './doCategorySearch';

const initCategorySearch = (searchInputSelector, searchBtnSelector) => {

	const searchInput = document.querySelector(searchInputSelector);

	if (!searchInput) {

		return;

	}

	const searchBtn = document.querySelector(searchBtnSelector);
	const searchHandler = (e) => {

		e.preventDefault();

		const value = searchInput.value.trim();

		if (value === '') {

			return;

		}

		const category = searchInput.getAttribute('data-category');

		doCategorySearch(searchInput.value.trim(), category);

	};

	searchBtn.addEventListener('click', (e) => {

		searchHandler(e);

	});

	searchInput.addEventListener('keydown', (e) => {

		if (e.key === 'Enter') {

			searchHandler(e);

		}

	});

};

export default initCategorySearch;
